import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Event, Router, NavigationEnd, NavigationStart, NavigationError } from '@angular/router';

import Swal from 'sweetalert2';
import { UserService } from '@core/auth/user/user.service';
import { Login } from '@core/auth/user/user';
import { ConfirmationModalConfig, ConfirmationModalService } from '@core/customCDK/cdkCustomMdl/services/confirmation-modal.service';
import { ConfirmationComponent } from '@core/customCDK/cdkCustomMdl/components/confirmation/confirmation.component';

@Injectable({
  providedIn: 'root',
})
export class CanActivateRouteGuard {

  initUrls = [
    '/getpreference',
  ]
  isAuthenticated: Login | null = this._UserService.loginData;
  constructor(
    private _UserService: UserService,
    private _Router: Router,
    private _ConfirmationModalService: ConfirmationModalService
  ) {
    this._Router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        // Show loading indicator

      }

      if (event instanceof NavigationEnd) {
        // Hide loading indicator

        let currenturl = event.urlAfterRedirects;

        if (this._UserService.loginData && this.initUrls.indexOf(currenturl) !== -1) {
          this._Router.navigate(['/digioonboard/onboarding']);
          // Swal.fire({
          //   title: 'Please complete Onboarding Process first.',
          //   icon: 'warning',
          //   confirmButtonColor: '#3085d6',
          //   confirmButtonText: 'Yes, do it!',
          //   allowOutsideClick: false
          // }).then((result) => {
          //   if (result.isConfirmed) {

          //   }
          // })
          const customConfig: ConfirmationModalConfig = {
            data: {
              icon: 'warning',
              msg: 'Please complete Onboarding Process first.',
              confirmButtonColor: '#3085d6',
              btnConfirm: 'Yes, do it!',
              btnClose: 'Cancel',
              showConfirmButton: false,
              allowOutsideClick: false,
              allowEscapeKey: false,
              showCancelButton: false
            },
          };
          this._ConfirmationModalService.init(ConfirmationComponent, customConfig).subscribe((events: any) => {
            events.initRef.close();
          });
        } else {

        }
      }

      if (event instanceof NavigationError) {
        // Hide loading indicator

        // Present error to user
      }
    });
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): UrlTree | boolean {

    if (!this._UserService.loginData) {
      this._Router.navigate(['/auth/login']);
      return this._Router.parseUrl(`/auth/login`);

    }
    return true;
  }
}
